import React, { useEffect, useRef, useState } from "react";
import { usePermissions } from "../../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import * as func from "../../../common/manipurCommon/FunctionCalls";
import * as api from "../../../common/manipurCommon/API";
import Utils from "../../../common/manipurCommon/Utils";
import ImageWithBasePath from "../../../../core/data/img/ImageWithBasePath";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Select from "react-select";
import { Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter, Button } from "react-bootstrap";
import Swal from "sweetalert2";

const HPCBatchAthlete = () => {

    const [batchList, setBatchList] = useState<any[]>([]);
    const [centerList, setCenterList] = useState<any[]>([]);
    const [athleteList, setAthleteList] = useState<any[]>([]);
    const [batchAthleteList, setBatchAthleteList] = useState<any[]>([]);
    const [geoList, setGeoList] = useState<any[]>([]);
    const [hpcList, setHpcList] = useState<any[]>([]);
    const [batchAthleteName, setBatchAthleteName] = useState("");
    const [geoId, setGeoId] = useState("");
    const [hpcId, setHpcId] = useState("");
    const [centerId, setCenterId] = useState("");
    const [batchId, setBatchId] = useState("");
    const [athleteId, setAthleteId] = useState("");
    const [batchAthleteStatus, setBatchAthleteStatus] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [showAthltLst, setShowAthltLst] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);
    const addcheckboxRefs = useRef([]);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    const customSelect = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: 'none',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    useEffect(() => {
        async function fetchBatchAthletes() {
            setIsLoading(true);
            const batchAthleteResponse = await func.hpcBatchAthelete(null);
            setBatchAthleteList(Array.isArray(batchAthleteResponse) ? batchAthleteResponse : [])
            setIsLoading(false);
        }
        fetchBatchAthletes();
    }, [])

    const filteredData = batchAthleteList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const batchNameRender = (rowData) => {
        return <span>{rowData.batchName}</span>;
    };

    const athleteNameRender = (rowData) => {
        return <span>{rowData.athleteName}</span>;
    };

    const batchAthleteStatusRender = (rowData) => {
        return <span>{(rowData.batchAthleteStatus == 1) ? "Active" : "Inactive"}</span>;

    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editBatchAthlete(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const btchAthleteId = rowData.batchAthleteId;
        return (
            <Link to="#" onClick={() => deleteBatchAthlete(btchAthleteId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    async function newBatchAthlete() {
        setIsEdit(false)
        setOpenModal(true)
        const geoResponse = await func.listGeoStates();
        setGeoList(Array.isArray(geoResponse) ? geoResponse : [])
        const batchResponse = await func.hpcBatch(null);
        setBatchList(Array.isArray(batchResponse) ? batchResponse : [])
        const centerResponse = await func.listGeoCenters();
        setCenterList(Array.isArray(centerResponse) ? centerResponse : [])
        setCenterId('')
        setBatchId('')
        setAthleteId('')
        setAthleteList([])
        setShowAthltLst(false)
    }

    async function editBatchAthlete(rowData: { batchAthleteId: string | number; }) {
        const btchAthleteId = rowData.batchAthleteId;
        setIsEdit(true)
        setOpenModal(true)
        setShowAthltLst(true)
        const batchResponse = await func.hpcBatch(null);
        setBatchList(Array.isArray(batchResponse) ? batchResponse : [])
        const centerResponse = await func.listGeoCenters();
        setCenterList(Array.isArray(centerResponse) ? centerResponse : [])
        const getDetails = await func.hpcBatchAthelete(btchAthleteId);
        setCenterId(getDetails.centerId);
        setBatchId(getDetails.hpcbatchId);
        setAthleteId(getDetails.athleteId);
        setBatchAthleteName(getDetails.athleteName);
        setBatchAthleteStatus(getDetails.batchAthleteStatus);
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateBatchAthlete();
            } else {
                const selectedathletes = addcheckboxRefs.current
                    .filter(checkbox => checkbox.checked)
                    .map(checkbox => Number(checkbox.value));                    

                if (batchId && selectedathletes) {
                    const formData = new FormData();
                    formData.append("batchId", batchId);
                    formData.append("athlete", JSON.stringify(selectedathletes));

                    const createBatchAthlete = api.HPCBatchAthlete;
                    fetch(createBatchAthlete, {
                        method: "POST",
                        headers: {
                            "Authorization": 'Bearer ' + Utils.getAccessToken()
                        },
                        body: formData
                    })
                        .then((response) => response.json())
                        .then((result) => {
                            if (result.error == false) {
                                Swal.fire({
                                    title: 'Success',
                                    text: result.message,
                                    icon: 'success',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        window.location.reload(); // 🔁 Reload only after OK is clicked
                                    }
                                });
                            } else {
                                if (result.code == 401) {
                                    Utils.logoutUser();
                                }
                                Swal.fire({
                                    title: 'Error',
                                    text: result.message,
                                    icon: 'error',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        window.location.reload(); // 🔁 Reload only after OK is clicked
                                    }
                                });
                            }
                        })
                }
            }
        }
    }

    function updateBatchAthlete() {
        const formData = new FormData();
        formData.append("batch", batchId);
        formData.append("athlete", athleteId);
        formData.append("status", batchAthleteStatus);

        const updatebtchathlete = api.HPCBatchAthlete + '/' + batchId;
        fetch(updatebtchathlete, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    function deleteBatchAthlete(btchAthleteId: string) {
        const deleteBatchAthlete = api.HPCBatchAthlete + '/' + btchAthleteId + '/' + 0;
        fetch(deleteBatchAthlete, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })

    }

    return (
        <>
            {isLoading && (

                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Batch Athletes</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newBatchAthlete() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Batch Athletes">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="batchName"
                                                header="Batch Name"
                                                body={batchNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="athleteName"
                                                header="Athlete Name"
                                                body={athleteNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="batchAthleteStatus"
                                                header="Batch Athlete Status"
                                                body={batchAthleteStatusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("edit") ?
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                : null
                                            }
                                            {currentPermissions.includes("delete") ?
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                openModal && (
                    <Modal
                        show={openModal}
                        size="md"
                        centered>
                        <ModalHeader>
                            <ModalTitle>
                                <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Batch Athlete</h4>
                            </ModalTitle>
                            <Button
                                variant=""
                                className="btn-close"
                                onClick={() => setOpenModal(false)}
                            ></Button>
                        </ModalHeader>
                        <ModalBody>
                            <form ref={formRef}>
                                <div className="row">
                                    <div className="col-lg-6 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">State Name</label>
                                            <Select
                                                value={geoList.find(state => state.geographyId === geoId) ? {
                                                    value: geoId,
                                                    label: geoList.find(state => state.geographyId === geoId).geographyName
                                                } : null}
                                                onChange={async (e) => {
                                                    setGeoId(e.value);
                                                    const hpcResponse = await func.getHpcByGeography(e.value);
                                                    setHpcList(Array.isArray(hpcResponse) ? hpcResponse : [])
                                                }}
                                                required
                                                styles={customSelect}
                                                placeholder="Select State"
                                                options={geoList.map(state => ({
                                                    value: state.geographyId,
                                                    label: state.geographyName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Center</label>
                                            <Select
                                                value={hpcList.find(hpc => hpc.geoHPCId === hpcId) ? {
                                                    value: hpcId,
                                                    label: hpcList.find(hpc => hpc.geoHPCId === hpcId).geoHPCName
                                                } : null}
                                                onChange={async (e) => {
                                                    setHpcId(e.value);
                                                    const btchResponse = await func.getBatchByHpc(e.value);
                                                    setBatchList(Array.isArray(btchResponse) ? btchResponse : [])
                                                }}
                                                required
                                                styles={customSelect}
                                                placeholder="Select Center"
                                                options={hpcList.map(hpc => ({
                                                    value: hpc.geoHPCId,
                                                    label: hpc.geoHPCName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Batch Name</label>
                                            <Select
                                                value={batchList.find(btch => btch.batchId === batchId) ? {
                                                    value: batchId,
                                                    label: batchList.find(btch => btch.batchId === batchId).batchName
                                                } : null}
                                                onChange={async (e) => {
                                                    setBatchId(e.value);
                                                    const athltResponse = await func.getAthletesByHpc(e.value);
                                                    setAthleteList(Array.isArray(athltResponse) ? athltResponse : [])
                                                    setShowAthltLst(true);
                                                }}
                                                required
                                                styles={customSelect}
                                                placeholder="Select Batch"
                                                options={batchList.map(btch => ({
                                                    value: btch.batchId,
                                                    label: btch.batchName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div>
                                    {showAthltLst ?
                                        <>
                                            <div className="court-information profile-availability">
                                                <div className="row accordion setting-accordion">
                                                    <div className="token-slot mt-2" style={{ maxHeight: "400px", overflowY: "auto" }}>
                                                        {athleteList.map((athlt, index) => (
                                                            <div key={index} className="form-check-inline visits court-information col-12 col-sm-2 col-md-3">
                                                                <label className="visit-btns">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        defaultValue={athlt.userId}
                                                                        ref={el => addcheckboxRefs.current[index] = el}
                                                                    />
                                                                    <span
                                                                        className="visit-rsn"
                                                                        data-bs-toggle="tooltip"
                                                                        title={athlt.athleteName}
                                                                    >
                                                                        {athlt.athleteName}
                                                                    </span>
                                                                    {/* <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    value={athlt.userId}
                                                                    required
                                                                    checked={athlt.userId === athleteId}  // ✅ highlight the athleteId from state
                                                                    onChange={() => setAthleteId(athlt.userId)} // ✅ update state on change
                                                                    ref={el => addcheckboxRefs.current[index] = el}
                                                                />
                                                                <span
                                                                    className="visit-rsn"
                                                                    data-bs-toggle="tooltip"
                                                                    title={athlt.athleteName}
                                                                >
                                                                    {athlt.athleteName}
                                                                </span> */}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </> : null
                                    }
                                </div>
                                {/* {isEdit ?
                                    <>
                                        <div className="row">
                                            <div className="col-lg-12 mb-10">
                                                <div className="input-space">
                                                    <label className="form-label">Athlete Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="athletename"
                                                        disabled={isEdit}
                                                        required
                                                        value={batchAthleteName}
                                                        onChange={(e) => setBatchAthleteName(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                <label className="form-label">Status</label>
                                            </div>
                                            <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                    <input
                                                        className="form-check-input text-end"
                                                        type="checkbox"
                                                        checked={batchAthleteStatus === '1'}
                                                        id="batchAthleteStatus"
                                                        onChange={(e) => {
                                                            setBatchAthleteStatus(e.target.checked ? '1' : '0')
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </> : null
                                } */}
                                <ModalFooter>
                                    <Button
                                        className="btn-primary text-uppercase"
                                        variant="success"
                                        type="submit"
                                        onClick={handleSubmit}
                                    >
                                        <b><i className="fas fa-save" />Save</b>
                                    </Button>
                                </ModalFooter>
                            </form>
                        </ModalBody>
                    </Modal >
                )
            }
        </>
    )
}

export default HPCBatchAthlete;